import { PersonJobType } from '@api';
import {
  TouringCard,
  TouringCardHeader,
  TouringCardSection,
  TouringCardTitle,
  TouringDataTable,
  useManageTableContext,
} from '@common';
import { useTranslation } from 'react-i18next';
import { useColumns } from '../../common';

type PreviousShowsPropsType = {
  previousShows: PersonJobType[];
  isPending: boolean;
};

export const PreviousShows: React.FC<PreviousShowsPropsType> = ({
  previousShows,
  isPending,
}) => {
  const { t } = useTranslation('personDetailsTourRep');
  const { columns } = useColumns();
  const { tableArguments: table } = useManageTableContext();

  return (
    <TouringCard data-testid="previous-shows-container">
      <TouringCardHeader>
        <TouringCardTitle>
          {t('TOUR_REP_SELF_PROMOTE.PREVIOUS_SHOWS.TITLE')}
        </TouringCardTitle>
      </TouringCardHeader>
      <TouringCardSection>
        <TouringDataTable<PersonJobType>
          records={previousShows}
          idAccessor="showTypeMinified.showId"
          columns={columns}
          {...table.pagination}
          withColumnBorders={false}
          withTableBorder={false}
          fetching={isPending}
        />
      </TouringCardSection>
    </TouringCard>
  );
};
